import { FC, ReactElement, cloneElement } from 'react';

import Tooltip from '@material-ui/core/Tooltip';

import {
  ActivityV1SlackAdminConfigState,
  getTypeOrNull,
  useExistsSlackQuery,
} from '@spotify/confidence-graphql';

interface SlackWorkspaceTooltipProps {
  children: ReactElement;
}

export const SlackWorkspaceTooltip: FC<SlackWorkspaceTooltipProps> = ({
  children,
}) => {
  const { data } = useExistsSlackQuery();
  const slack = getTypeOrNull(data?.existsSlack);
  const isWorkspaceNotConfigured =
    !slack || slack.state === ActivityV1SlackAdminConfigState.NotConfigured;

  const childWithDisabled = cloneElement(children, {
    disabled: isWorkspaceNotConfigured,
  });
  return (
    <Tooltip
      title={
        isWorkspaceNotConfigured
          ? 'Your workspace must first be connected. Ask your admin.'
          : ''
      }
      arrow
    >
      <span>{childWithDisabled}</span>
    </Tooltip>
  );
};
